import { authSplitApi } from '../helpers/slice.helpers';
import { TCreateQuestionUI, TCreateVideoLinkUI, TQuestionDB, TQuestionUI, TVideoLinkDB, TVideoLinkUI } from 'data/types/faq.types';
import { createQuestionsConverter, createVideoLinksConverter, questionConverter, questionsListConverter, videoLinksListConverter } from 'data/convertors/faq.converters';

export const faqApi = authSplitApi('faq', ['faq-question', 'faq-videlinks']).injectEndpoints({
  endpoints: (build) => ({
    getAdminQuestion: build.query<TQuestionUI[], void>({
      query() {
        return {
          url: `faq/question`,
          method: 'GET',
        };
      },
      transformResponse: (data: TQuestionDB[]) => {
        return questionsListConverter.fromDb(data);
      },
      providesTags: ['faq-question'],
    }),

    getAdminVideoLinks: build.query<TVideoLinkUI[], void>({
      query() {
        return {
          url: `faq/video`,
          method: 'GET',
        };
      },
      transformResponse: (data: TVideoLinkDB[]) => {
        return videoLinksListConverter.fromDb(data);
      },
      providesTags: ['faq-videlinks'],
    }),

    createQuestions: build.mutation<void, TCreateQuestionUI[]>({
      query(body) {
        return {
          url: `faq/question`,
          method: 'POST',
          body: {
            questions: createQuestionsConverter.toDb(body),
          },
        };
      },
      invalidatesTags: ['faq-question'],
    }),

    editQuestion: build.mutation<void, TQuestionUI>({
      query(body) {
        return {
          url: `faq/question`,
          method: 'PATCH',
          body: {
            question: questionConverter.toDb(body),
          },
        };
      },
      invalidatesTags: ['faq-question'],
    }),

    deleteQuestion: build.mutation<void, string>({
      query(id) {
        return {
          url: `faq/question`,
          method: 'DELETE',
          body: {
            id,
          },
        };
      },
      invalidatesTags: ['faq-question'],
    }),

    reorderQuestions: build.mutation<void, string[]>({
      query(body) {
        return {
          url: `faq/question/order`,
          method: 'PUT',
          body: {
            questionIds: body,
          },
        };
      },
      invalidatesTags: ['faq-question'],
    }),

    addVideoLinks: build.mutation<void, TCreateVideoLinkUI[]>({
      query(body) {
        return {
          url: `faq/video`,
          method: 'POST',
          body: {
            videos: createVideoLinksConverter.toDb(body),
          },
        };
      },
      invalidatesTags: ['faq-videlinks'],
    }),

    editVideoLinks: build.mutation<void, TVideoLinkUI[]>({
      query(body) {
        return {
          url: `faq/video`,
          method: 'PUT',
          body: {
            videos: videoLinksListConverter.toDb(body),
          },
        };
      },
      invalidatesTags: ['faq-videlinks'],
    }),

    deleteAllVideoLinks: build.mutation<void, void>({
      query() {
        return {
          url: `faq/video/all`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['faq-videlinks'],
    }),
  }),
});

export const {
  useGetAdminQuestionQuery,
  useGetAdminVideoLinksQuery,
  useCreateQuestionsMutation,
  useEditQuestionMutation,
  useDeleteQuestionMutation,
  useAddVideoLinksMutation,
  useEditVideoLinksMutation,
  useDeleteAllVideoLinksMutation,
  useReorderQuestionsMutation,
} = faqApi;
